export default {
  common: {
    create: '创建',
    connectWallet: '连接钱包',
    language: {
      en: '英文',
      zh: '中文'
    },
    loading: '加载中...',
    success: '成功',
    failed: '失败',
    confirm: '确认',
    cancel: '取消',
    close: '关闭',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    search: '搜索',
    noData: '暂无数据',
    retry: '重试',
    back: '返回',
    next: '下一步',
    submit: '提交',
    hours: '小时'
  },
  sidebar: {
    home: '首页',
    board: '代币列表',
    createCoin: '创建代币',
    myWallet: '我的钱包',
    more: '更多',
    menu: {
      howItWorks: '使用说明',
      support: '支持'
    },
    footer: {
      email: '邮箱：contact@yolopad.fun',
      copyright: '© 2025 YOLOPad. 版权所有'
    }
  },
  game: {
    title: 'YOLO 游戏',
    description: '加入 YOLO 游戏，赢取大奖！',
    status: {
      active: '进行中',
      ended: '已结束',
      upcoming: '即将开始'
    },
    round: {
      current: '当前轮次',
      total: '总轮次',
      participants: '参与人数',
      deposit: '总存款',
      burned: '总销毁',
      reward: '奖励池'
    },
    actions: {
      mint: '铸造',
      burn: '销毁',
      claim: '领取',
      deposit: '存款',
      withdraw: '提款'
    },
    messages: {
      mintSuccess: '铸造成功！',
      burnSuccess: '销毁成功！',
      claimSuccess: '领取成功！',
      depositSuccess: '存款成功！',
      withdrawSuccess: '提款成功！',
      roundEnded: '本轮已结束',
      roundNotStarted: '本轮尚未开始',
      insufficientBalance: '余额不足',
      maxParticipantsReached: '已达到最大参与人数',
      minCapNotReached: '未达到最小募集额',
      maxRoundReached: '已达到最大轮次'
    },
    tokenInfo: {
      createAt: '创建时间',
      totalSupply: '总供应量',
      totalBurned: '总销毁量',
      mintPrice: '铸造价格',
      trade: '交易',
      copy: '复制',
      token: '代币',
      game: '游戏',
      createBy: '创建者'
    },
    roundInfo: {
      title: '轮次信息',
      status: {
        ended: '已结束',
        notStarted: '未开始',
        launchFailed: '发射失败',
        minting: '铸造中',
        waiting: '等待中',
        burning: '销毁中',
        claiming: '领取中'
      },
      stats: {
        round: '轮次',
        totalMinter: '总铸造者',
        totalBurner: '总销毁者',
        minted: '已铸造',
        burned: '已销毁'
      },
      progress: {
        minCap: '最小募集额',
        timeRemaining: '剩余时间'
      },
      refund: '退款'
    },
    rewards: {
      title: '排行榜分配',
      rewardPool: '奖励池',
      rank: '排名',
      address: '地址',
      burnedAmount: '销毁数量',
      reward: '奖励'
    },
    gameInfo: {
      title: '游戏信息',
      totalRounds: '总轮次',
      minCap: '最小目标',
      mintingTime: '铸造时长',
      burningTime: '销毁时长',
      rollRate: '滚动率'
    },
    operation: {
      mint: {
        title: '输入铸造数量',
        button: '铸造',
        totalMinted: '游戏总铸造量'
      },
      burn: {
        title: '输入销毁数量',
        button: '销毁',
        holdingAmount: '持有数量'
      }
    },
    roundHistory: {
      title: '轮次历史',
      status: {
        active: '进行中',
        completed: '已完成',
        upcoming: '即将开始'
      },
      details: {
        round: '轮次',
        view: '查看详情',
        hide: '隐藏详情',
        minter: '铸造者',
        minted: '已铸造',
        burner: '销毁者',
        burned: '已销毁',
        rewardPool: '奖励池',
        yourData: '你的数据',
        mintedAmount: '铸造数量',
        burnedAmount: '销毁数量',
        rank: '排名',
        claimableReward: '可领取奖励',
        claimStatus: '领取状态',
        claimed: '已领取',
        claim: '领取',
        noWinners: '暂无获奖者',
        loadingWinners: '加载获奖者数据...'
      }
    },
    errors: {
      connectWallet: '请连接钱包',
      networkError: '网络错误',
    }
  },
  create: {
    basicSetting: '基础设置',
    advancedSetting: '高级设置',
    name: '名称',
    ticker: '代币符号',
    description: '描述(最多180字)',
    imageOrVideo: '图片或视频',
    selectFile: '选择文件',
    selectFileTip: '选择图片或视频(最大10MB)',
    minCap: '最小募集额(最小0.01{{token}})',
    minCapTip: '最小募集额是第一轮可以募集的最小金额。如果未达到，则启动失败并可以退款',
    maxRound: '最大轮次',
    maxRoundTip: '最大轮次是可以创建的最大轮次数',
    roundDuration: '轮次时长(小时)',
    roundDurationTip: '轮次时长是指每轮铸造和销毁的持续时间，不能少于0.1小时',
    rolloverRate: '回滚率(10~100)',
    rolloverRateTip: '游戏奖励池中的资金将按照回滚率(百分比)分配到下一轮',
    rewardRanks: '奖励排名',
    rewardRanksTip: '设置奖励排名列表的分配比例。总值 + 回滚率不能大于100',
    telegramLink: 'Telegram链接',
    websiteLink: '网站链接',
    twitterLink: 'Twitter或X链接',
    showMore: '显示更多选项 ↓',
    hideMore: '隐藏更多选项 ↑',
    createCoin: '创建代币',
    createTip: '提示：创建后无法更改代币数据',
    placeholder: {
      minCap: '例如：10',
      maxRound: '例如：10',
      roundDuration: '例如：1',
      rolloverRate: '最小10',
      rank: '排名 {{index}}',
      optional: '(可选)'
    }
  },
  validation: {
    minCap: {
      required: '请输入最小募集额',
      invalidFormat: '请输入最多2位小数的有效数字'
    },
    maxRound: {
      required: '请输入最大轮次',
      invalidFormat: '请输入有效的整数'
    },
    roundDuration: {
      required: '请输入轮次时长',
      invalidFormat: '请输入最多2位小数的有效数字',
      tooSmall: '值必须至少为0.1'
    },
    rolloverRate: {
      required: '请输入回滚率',
      invalidRange: '请输入10到100之间的数字'
    },
    name: {
      required: '请输入名称',
      tooLong: '名称不能超过50个字符'
    },
    ticker: {
      required: '请输入代币符号',
      tooLong: '代币符号不能超过10个字符',
      invalidFormat: '代币符号只能包含字母和数字'
    },
    description: {
      required: '请输入描述',
      tooLong: '描述不能超过180个字符'
    },
    links: {
      invalidTelegram: '请输入有效的Telegram链接 (https://t.me/...)',
      invalidTwitter: '请输入有效的Twitter/X链接',
      invalidWebsite: '请输入有效的网站URL'
    },
    file: {
      required: '请选择文件',
      tooLarge: '文件大小必须小于10MB',
      invalidType: '无效的文件类型',
      uploadFailed: '上传失败，请重试'
    },
    reward: {
      invalidRange: '请输入0到100之间的数字',
      totalExceeded: '总奖励({{total}}%)不能超过100%。请调整您的数值。'
    }
  },
  errors: {
    networkError: '网络错误',
    insufficientBalance: '余额不足',
    transactionFailed: '交易失败',
    connectWallet: '请连接钱包并选择网络',
    contractNotDeployed: '当前网络未部署合约',
    gameCreationFailed: '创建游戏失败',
    transactionRejected: '用户拒绝了交易',
    insufficientFunds: '余额不足以完成交易',
    walletConnectionFailed: '钱包连接失败',
    networkSwitchFailed: '网络切换失败',
    contractCallFailed: '合约调用失败',
    gasEstimationFailed: 'Gas估算失败',
    unknownError: '发生未知错误'
  },
  toast: {
    success: {
      title: '成功',
      message: '操作成功完成'
    },
    error: {
      title: '错误',
      message: '操作失败'
    },
    warning: {
      title: '警告',
      message: '请检查您的输入'
    },
    info: {
      title: '提示',
      message: '请注意'
    }
  },
  mywallet: {
    walletAddress: '钱包地址：',
    invitedRewards: '邀请奖励：',
    inviter: '邀请人：',
    bindInviter: '绑定邀请人',
    inviteLinkPrefix: '点击复制邀请链接：',
    shareMessage: '分享您的邀请链接以获得奖励',
    shareToX: '分享到 X',
    tabs: {
      invitationList: '邀请列表',
      myCreate: '我的创建',
      myFavorite: '我的收藏'
    },
    noData: '暂无数据',
    modal: {
      enterInviteCode: '请输入邀请码',
      invalidCode: '无效的邀请码，请检查后重试',
      bindFailed: '绑定邀请人失败，请检查邀请码或重试'
    },
    toast: {
      inviteLinkCopied: '邀请链接已复制到剪贴板！'
    }
  },
  modal: {
    bindInviter: '绑定邀请人',
    cancel: '取消',
    confirm: '确认'
  },
  home: {
    title: '你只需发射一次',
    subtitle: '创建、铸造、销毁和赢取 — YOLOPad 是代币诞生和战斗开始的地方',
    joinButton: '加入战斗',
    features: {
      launch: {
        title: '发行代币',
        description: '成为下一个MEME霸主。一分钟内部署代币 + 规则 + 混乱。'
      },
      mint: {
        title: '铸造加入',
        description: '尽早参与。固定价格，限时铸造。越早铸造，赢得越便宜。'
      },
      burn: {
        title: '销毁赢取',
        description: '销毁代币登上排行榜。销毁排行榜瓜分奖励池。'
      },
      invite: {
        title: '邀请赚取',
        description: '链上推荐。从被邀请者的铸造中获得 1% 实时奖励。即时有效。'
      },
      arb: {
        title: '套利交易',
        description: '平台铸造，DEX交易。价格差 = 利润，如果你够快的话。'
      },
      lottery: {
        title: '平台奖池',
        description: '实时触发大奖。如果你铸造了，你可能就是赢家。'
      }
    },
    footer: '⚡ 一些早期用户可能会出现在某个名单上。我们不会说这是什么～'
  },
  gameList: {
    address: '地址：',
    creator: '创建者：',
    minCap: '最小募集额：',
    loading: '加载中...',
    loadMore: '加载更多',
    errors: {
      connectWallet: '请连接钱包并选择网络',
      networkError: '获取数据失败。请检查网络连接或切换网络。',
      contractNotDeployed: '当前网络未部署合约'
    },
    progress: {
      failed: '失败',
      percent: '{{percent}}%'
    }
  },
  luckdraw: {
    lotteryStatus: '开奖状态',
    loading: '加载中...',
    completed: '已开奖',
    started: '抽奖进行中',
    notStarted: '未开始',
    participants: '参与者列表',
    noParticipants: '暂无参与者',
    winners: '中奖者列表',
    noWinners: '暂无中奖者',
    notDrawn: '尚未开奖',
    yourStatus: '我的抽奖状态',
    notConnected: '请先连接钱包',
    isParticipant: '你已参与抽奖',
    notParticipant: '你未参与抽奖',
    isWinner: '恭喜你中奖了！',
    notWinner: '很遗憾，未中奖'
  }
}; 